import { Card } from "@qpd-reestr/ui-kit"
import { getMessageByCode } from "../../utils"
import { ErrorCode } from "../../models"
import { FormLayout } from '../../containers';
import './TimeDesynchronizationPage.less'
import { ConsentDecorator } from "../../components/RoutesDecorator/ConsentDecorator";
import { TimeSyncDecorator } from "../../components/RoutesDecorator/TimeSyncDecorator";

/**
 * Страница отображения ошибки при рассинхронизации по времени с сервером.
 */
const TimeDesynchronizationPage: React.FC = () => {
    return (
        <ConsentDecorator>
            <TimeSyncDecorator>
                <FormLayout>
                    <div className="qpd-rstr-time-desynchronization-page">
                        <Card className="qpd-rstr-time-desynchronization-card">
                            {getMessageByCode(ErrorCode.TimeDesynchronization)}
                        </Card>
                    </div>
                </FormLayout>
            </TimeSyncDecorator>
        </ConsentDecorator>
    )
}

/**
 * Название компонента, испольуемое при отладке.
 */
TimeDesynchronizationPage.displayName = 'TimeDesynchronizationPage';

export default TimeDesynchronizationPage